import { useStyles } from "@/styles/useStyles";
import { Group, Stack } from "@mantine/core";
import { Text } from "../ui/Text";
import { useActiveAssignment } from "@/store/selectors/assignmentSelectors";
import { Button } from "../ui/Button";
import { IconExternalLink } from "@tabler/icons-react";
import { Analytics } from "@/services/Analytics";
import { AssignmentService } from "@/services/AssignmentService";
import { useActiveUser } from "@/store/selectors";

export function AssignmentSessionScheduler() {
  const { theme } = useStyles();
  const activeAssignment = useActiveAssignment();
  const activeUser = useActiveUser();

  if (!activeAssignment?.sessionSchedulingLink) return null;

  const title = "Want some 1-on-1 career support?";

  return (
    <Stack
      p="xl"
      py="md"
      gap={0}
      bg={theme.colors.background[0]}
      style={{
        borderRadius: 8,
        border: `2px solid ${theme.colors.border[3]}`,
      }}
    >
      <Group justify="space-between" wrap="nowrap" align="center">
        <Text titleStyle="h4" fw={700}>
          {title}
        </Text>
        <Button
          color="primary"
          size="xs"
          rightSection={<IconExternalLink size={16} />}
          onClick={() => {
            const link = activeAssignment?.sessionSchedulingLink;
            if (!link) return;
            if (!activeAssignment?.id) return;
            if (!activeUser?.id) return;

            Analytics.click({
              action: "Assignment Session Scheduler > Schedule a session",
              label: activeAssignment?.sessionSchedulingLink,
            });

            AssignmentService.updateUserAssignmentResponse({
              assignmentId: activeAssignment?.id,
              studentUserId: activeUser?.id,
              promptId: "sessionSchedulingLink",
              response: "Yes",
            });

            // Ensure the link has a protocol to go to another website
            const url =
              link.startsWith("http://") || link.startsWith("https://")
                ? link
                : `https://${link}`;

            window.open(url, "_blank");
          }}
        >
          Schedule a session
        </Button>
      </Group>
    </Stack>
  );
}
